import { Typography } from 'shared';
import { dateUtils } from 'shared_DEPRECATED/utils';

import { Tooltip } from 'shared/components/Tooltip';

type TGoalCreatedAt = {
  createdAt: string;
};

export const Createdat = ({ createdAt }: TGoalCreatedAt) => (
  <Tooltip content="Created">
    <Typography
      as="span"
      type="xsm"
      color="gray"
      fontWeight="medium"
      whiteSpace="nowrap"
    >
      {dateUtils(createdAt).format('D MMM, YYYY')}
    </Typography>
  </Tooltip>
);
